import { breakpoints } from '@bnnvara/breakpoints';
import { animated } from 'react-spring';
import styled from 'styled-components';

import appConfig from '../../config/app.json';

const Overlay = styled(animated.div)`
  background: ${({ theme }) => theme.base.white};
  overflow: hidden;
  position: fixed;
  z-index: 13;
  left: 0;
  right: 0;
  top: ${appConfig.layout.hubHeight}px;
  box-shadow: rgba(0, 0, 0, 0.25) 0 0 10vh;

  ${breakpoints.md} {
    top: ${appConfig.layout.hubHeightMd}px;
  }
`;

export default Overlay;
